/* eslint-disable no-case-declarations */
import { useOktaAuth } from '@okta/okta-react';
import { LoadingIndicator } from '@triumph/design-system';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';

import { PageRoutes } from '@/app/components/router/routes';
import { AuthenticationStatus } from './Authentication.types';
import { SignIn } from './SignIn';
import { AuthenticationContainer } from './Authentication.StyledComponents';

export const Authentication = () => {
  // get translations
  const { t } = useTranslation('authentication');
  const translations = {
    authLoading: t('authLoadingMessage'),
  };

  // set up component state
  const [authenticationStatus, setAuthenticationStatus] =
    useState<AuthenticationStatus>(AuthenticationStatus.SIGN_IN);

  // call hooks
  const location = useLocation();
  const { oktaAuth, authState } = useOktaAuth();

  // define variables
  const referrer: string = location?.state?.referrer || '';
  const searchParams: string = location?.state?.search;
  let deepLink = referrer;
  if (searchParams) deepLink += searchParams;

  useEffect(() => {
    if (
      authState?.isAuthenticated &&
      authenticationStatus !== AuthenticationStatus.AUTHENTICATED
    ) {
      setAuthenticationStatus(AuthenticationStatus.AUTHENTICATED);
    }
  }, [authState]);

  switch (authenticationStatus) {
    case AuthenticationStatus.AUTHENTICATED:
      if (authState?.isAuthenticated) {
        const navPath = deepLink || PageRoutes.DASHBOARD;
        return <Navigate to={navPath} />;
      } else if (oktaAuth) {
        if (deepLink) {
          oktaAuth.setOriginalUri(deepLink);
        }
      }
      return (
        <AuthenticationContainer>
          <LoadingIndicator
            loadingTestId="styled-loading-indicator"
            message={translations.authLoading}
            show={true}
            delay={0}
          />
        </AuthenticationContainer>
      );
    case AuthenticationStatus.SIGN_IN:
      if (authState?.isAuthenticated) {
        setAuthenticationStatus(AuthenticationStatus.AUTHENTICATED);
        return null;
      }
      return <SignIn />;
    default:
      return <LoadingIndicator show={true} />;
  }
};
